import { ModelSagres } from "../model-sagres";

export class VisualizacaoAviso extends ModelSagres {
  idVisualizacao: number;
  dataVisualizacao: Date;
  nomeUsuario: string;
  unidadeGestora: string;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.idVisualizacao = obj.idVisualizacao;
      this.dataVisualizacao = new Date(obj.dataVisualizacao);
      this.nomeUsuario = obj.nomeUsuario;
      this.unidadeGestora = obj.unidadeGestora;
    }
  }
}
